import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';

import type { TSetting } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class SettingsService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TSetting> {
        const path = this.firestorePathsService.getSettingsPath();
        // const observable = this.firestoreService.getObservable(path) as Observable<TSetting>;
        const observable = this.firestoreService.getObservable(path) as Observable<TSetting>;
        return observable;
    }

    public async getByAccountNumber(accountNumber: string): Promise<TSetting> {
        const ref = this.firestorePathsService.getSettingsByAccountNumberRef(accountNumber);
        return this.firestoreService.get(ref) as Promise<TSetting>;
    }

    public async get(): Promise<TSetting> {
        const path = this.firestorePathsService.getSettingsPath();
        return await this.firestoreService.get(path) as TSetting;
    }

    public async set(setting: TSetting): Promise<TSetting> {
        setting.uid = 'setting';
        const path = this.firestorePathsService.getSettingsPath();
        await this.firestoreService.set(path, setting);
        return setting;
    }

    public async update(setting: TSetting): Promise<TSetting> {
        const path = this.firestorePathsService.getSettingsPath();
        await this.firestoreService.set(path, setting);
        return setting;
    }

    public async writeToFirebaseStorage(filename: string, data: string) {
        return this.firestoreService.writeToFirebaseStorage(filename, data);
    }
}
